import { InputProps } from 'interfaces';
import * as React from 'react';
import { Input } from '../input/input';

interface InputPhoneProps {
	customErrorMessage?: string;
}

export const InputPhone: React.FC<
	InputProps & InputPhoneProps & React.InputHTMLAttributes<HTMLInputElement>
> = ({ name, setValueInput, customErrorMessage, rules, ...props }) => {
	const onKeyDownHandler = (event: any): void => {
		// Allowing control shortcuts (Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X, etc)
		if (event.ctrlKey || event.metaKey) {
			return;
		}

		// Block any single character that is not a digit
		if (event.key && event.key.length === 1 && !/\d/.test(event.key)) {
			event.preventDefault();
		}
	};

	const handleChange = (e: React.ChangeEvent<any>): void => {
		const val = e.target.value.replace(/\D/g, '');
		e.target.value = val;
		setValueInput(name, val);
	};

	const finalRules = React.useMemo(() => {
		return {
			...rules,
			minLength: {
				value: 10,
				message:
					customErrorMessage || 'The number must have at least 10 numbers',
			},
		};
	}, [rules]);

	return (
		<>
			<Input
				name={name}
				type="tel"
				onChangeCustom={handleChange}
				onKeyDown={onKeyDownHandler}
				maxLength={10}
				rules={finalRules}
				{...props}
			></Input>
		</>
	);
};
